import { useEffect, useMemo, useState } from 'react';

import { PageModel } from '@adobe/aem-react-editable-components';

const useDropdownMocks = (fragmentVariationPath: string | undefined) => {
	const [mockedModel, setMockedModel] = useState<PageModel | undefined>(
		undefined,
	);

	const mockedModelSegment = useMemo(() => {
		if (fragmentVariationPath === undefined) return undefined;

		const lastSegment = fragmentVariationPath.split('/').pop();

		const allowedSegments = [
			'vehicles-dropdown',
			'shop-now-dropdown',
			'owners-dropdown',
			'explore-dropdown',
			'your-builds',
			'language-selector',
			'my-account',
			'contact-and-help',
		];

		if (lastSegment && allowedSegments.includes(lastSegment))
			return lastSegment;
	}, [fragmentVariationPath]);

	useEffect(() => {
		const loadMockedModel = async () => {
			const { default: mocked } = await import(
				`./../../../vite-mocked-endpoints/${mockedModelSegment}.model.json`
			);

			setMockedModel(mocked as unknown as PageModel);
		};

		if (fragmentVariationPath && mockedModelSegment) loadMockedModel();
	}, [fragmentVariationPath, mockedModelSegment]);

	return mockedModel;
};

export { useDropdownMocks };
